import { render, staticRenderFns } from "./Bookcase.vue?vue&type=template&id=2ad10c7a&scoped=true"
import script from "./Bookcase.vue?vue&type=script&lang=js"
export * from "./Bookcase.vue?vue&type=script&lang=js"
import style0 from "./Bookcase.vue?vue&type=style&index=0&id=2ad10c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad10c7a",
  null
  
)

export default component.exports